require('./passwordController');

angular.module('app.shared.password.passwordDirective', [
  'app.shared.password.passwordController'
])
  .directive('passwordChecker', [
    () => {
      "use strict";

      return {
        restrict: 'E',
        controller: 'app.shared.password.passwordController',
        templateUrl: 'components/shared/password/passwordView.html',
        scope: {
          password: '=',
          passwordPass: '='
        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/password/passwordDirective.js